import { RestService, Rest } from '@abp/ng.core';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class WineAvailabilityCacheService {
  apiName = 'Default';
  

  refreshWineAvailabilityCache = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'POST',
      url: '/api/app/wine-availability-cache/refresh-wine-availability-cache',
    },
    { apiName: this.apiName,...config });

  constructor(private restService: RestService) {}
}
